import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, makeStyles } from "@material-ui/core";
import { LinearProgress, Typography } from "@mui/material";
import { Box } from '@mui/system';
import "./styles.scss";
import { connect } from 'react-redux';
import { getStoryLength } from '../redux/actions/buddyBooks';
import { Close } from '@material-ui/icons';
import { logout } from '../redux/actions/auth';
import { useHistory } from "react-router-dom";
import Confetti from 'react-confetti';

const useStyles = makeStyles({
    root: {
        height: "6px !important",
        border: "1px solid #222",
        borderRadius: 4
    }
})

function ProgressBar({ total, current, storyLength, dispatch, storyId, isStoryComplete, playerType, restart }) {
    const classes = useStyles();
    const [progress, setProgress] = useState(0);
    const [showComplete, setShowComplete] = useState(isStoryComplete);

    const history = useHistory();

    useEffect(() => {
        dispatch(getStoryLength(storyId));
    }, [])

    useEffect(() => {
        const calculateProgress = () => {
            // let progressNum = Number(total && total.storySegmentDto && total.storySegmentDto.length);
            let progressNum = Number(storyLength);
            console.log("progressNum, current ", progressNum, current);
            let progressCent = (((current + 1)*100)/progressNum).toFixed(2);
            if(progressCent > 100) {
                setProgress(100);
            }else {
                setProgress(progressCent);
            }
        }
        if(playerType){
            calculateProgress();
        }
    }, [total, current])

    useEffect(() => {
        setShowComplete(isStoryComplete);
    }, [isStoryComplete])
    const handleClose = () => {
        setShowComplete(false)
    }
    const handleLogout = () => {
        document.body.style.background = "#ddf0ff";

        //clearing local storage keys
        localStorage.setItem(`review_done`, "false");
        let keysToRemove = ["logged_user", "reporting_time", "book_id", "current_section"];

        for (let key of keysToRemove) {
            localStorage.removeItem(key);
        }

        dispatch(logout());
        window.getStoryCalled = false;
        window.getSavedSessionCalled = false;
        window.getSettingsCalled = false;
        setTimeout(() => {
            history.push("/");
        }, 500);
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" color="secondary" className={classes.root} value={progress ? Number(progress) : 0} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="white" fontWeight="fontWeightBold" >{progress ? progress : 0}%</Typography>
                </Box>
            </Box>
            {showComplete && <Confetti />}
            <Dialog open={showComplete} onClose={(_,reason)=>{if(!reason){handleClose()}}}
                fullWidth={true} maxWidth={'md'} maxHeight={'md'} >
                {/* <DialogTitle id='form-dialog-title' disableTypography style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }} >
                    <div></div>
                    <IconButton
                        onClick={handleClose}
                        aria-label="close dialog">
                        <Close />
                    </IconButton>
                </DialogTitle> */}
                <DialogContent dividers>
                    <Typography variant='h3' textAlign={"center"} color="green">Great job, you have finished your book!</Typography>
                    <br/>
                    <Typography variant='h4' textAlign={"center"}>
                        Please ask your teacher or parent to assign you a new book.
                    </Typography>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        <Button onClick={handleLogout} variant="contained" size="large">
                            Logout
                        </Button>
                        <Button onClick={()=>{handleClose();restart()}} style={{marginLeft:'20px'}} variant='contained' size='large'>
                        Read this book again
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>

    )
}

const mapState = ({ platform: { analysis: { storyLength } } }) => {
    return {
        storyLength
    }
};

export default connect(mapState)(ProgressBar);